import { render } from "./RelatedHotel.vue?vue&type=template&id=72a50aac"
import script from "./RelatedHotel.vue?vue&type=script&lang=js"
export * from "./RelatedHotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__